<template>
  <div>
    <NavBar />
    
    <div>
      <storeProduct />
    </div>

<!--     <div class="cantSee">{{ reversedMessage }}</div>
    <div v-if="!dropStarted">
      <div class="container">
      <h1 id="headline">Countdown For Shop Drop!</h1>
      <div id="countdown">
        <ul>
          <li><span id="hours">{{hours}}</span>Hours</li>
          <li><span id="minutes">{{minutes}}</span>Minutes</li>
          <li><span id="seconds">{{seconds}}</span>Seconds</li>
        </ul>
      </div>
      </div>
    </div> -->
    
    <Footer />
  </div>
</template>

<script>
import NavBar from "./Navigation/NavBar.vue";
import Footer from "./Navigation/Footer.vue";
import storeProduct from "./Store/storeProduct.vue";
import axios from 'axios';
export default {
  data: function() {
    return {
      dropStarted : false,
      dropDate: 1650931200,
      hours: 0,
      days: 0,
      minutes: 0,
      seconds: 0,
      timeNow: 1650931200,
    }
  },
  created() {
    window.location.href = "https://chimbastudios.com/cosmic-labs"; // Replace with your desired URL
  },
  components: {
    NavBar,
    Footer,
    storeProduct
  },
  methods:{
    async getTime()
    {
      await axios.get('http://worldtimeapi.org/api/timezone/America/Toronto')
      .then(res=> {

        this.timeNow = res.data.unixtime;
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
      });
    }
  },
  computed: {
    reversedMessage: function() {
      var countDownDate = new Date(this.dropDate * 1000).getTime();

      var globalClock = this;
      setInterval(
        function() {
          
          
          var now = new Date(globalClock.timeNow * 1000).getTime();
          var timeleft = countDownDate - now;

          var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));

          var hours = Math.floor(
            (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );

          hours = hours + days * 24;
          
          if (hours < 10) {
            globalClock.hours = "0" + hours;
          } else globalClock.hours = hours;
          if (hours < 0) globalClock.hours = 0;
          var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
          if (minutes < 10) {
            globalClock.minutes = "0" + minutes;
          } else globalClock.minutes = minutes;
          if (minutes < 0) globalClock.minutes = 0;
          var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
          if (seconds < 10) {
            globalClock.seconds = "0" + seconds;
          } else globalClock.seconds = seconds;
          if (seconds < 0) globalClock.seconds = 0;
          if (countDownDate - now > 0) {
            globalClock.dropStarted = false;
          } else globalClock.dropStarted = true;
        },
        1000,
        this
      );
    }
  },
};
</script>

<style scoped>
.headingImage {
  width: 100%;
}
.container {
  color: white;
  margin: 0 auto;
  text-align: center;
  margin-top: 30vh;
  margin-bottom: 30vh;
}

h1 {
  font-weight: normal;
  letter-spacing: .125rem;
  text-transform: uppercase;
}

li {
  display: inline-block;
  font-size: 1.5em;
  list-style-type: none;
  padding: 1em;
  text-transform: uppercase;
}

li span {
  display: block;
  font-size: 4.5rem;
}

.emoji {
  display: none;
  padding: 1rem;
}

.emoji span {
  font-size: 4rem;
  padding: 0 .5rem;
}

@media all and (max-width: 768px) {
  h1 {
    font-size: calc(1.5rem * var(--smaller));
  }
  
  li {
    font-size: calc(1.125rem * var(--smaller));
  }
  
  li span {
    font-size: calc(3.375rem * var(--smaller));
  }
}
.cantSee {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Shop.vue